/**
 * The external-facing D9 surfaces (client portal, buyer intake, roleplayer
 * partners) and a predicate for them (#3534).
 *
 * Those routes own their own browser chrome (title, theme-color, theme key),
 * so CRM-wide effects that would otherwise stamp the CRM's (e.g.
 * BrandingProvider's "{agency} CRM" document title) check this first.
 */
export const PORTAL_ROUTE_PREFIXES = ["/portal", "/intake", "/partners"] as const;

export function isPortalPath(pathname: string): boolean {
  return PORTAL_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
